import { UserDataResult } from 'angular-auth-oidc-client';

export function isAdmin(user?: UserDataResult) {
  return hasRole('Admin', user);
}

export function isInternalRegional(user?: UserDataResult) {
  return hasRole('InternalRegional', user);
}

export function hasRole(role: string, user?: UserDataResult) {
  return user?.userData?.role === role || user?.userData?.extension_Role === role;
}
